/* eslint-disable spire/export-styles */
import AddedToCartModal from "@bevco/Components/AddedToCartModal";
import AddToListModal from "@bevco/Components/AddToListModal";
import ShareListModal from "@bevco/Components/ShareListModal";
import InventoryResultsModal from "@bevco/Widgets/VerndaleBox/InventoryResultsModal";
import SpoolModal from "@bevco/Widgets/VerndaleBox/SpoolModal";
import ManageShareListModal from "@insite/content-library/Components/ManageShareListModal";
import ProductDeliveryScheduleModal from "@insite/content-library/Components/ProductDeliveryScheduleModal";
import ProductSelectorVariantModal from "@insite/content-library/Components/ProductSelectorVariantModal";
import ShareListDetailModal from "@insite/content-library/Components/ShareListDetailModal";

import * as React from "react";

interface OwnProps {
    skipInventoryValidation?: boolean;
    skipProductPrice?: boolean;
}

type Props = OwnProps;

const Modals = ({ skipInventoryValidation, skipProductPrice }: Props) => (
    <>
        <ManageShareListModal />
        <ShareListDetailModal />
        <ProductSelectorVariantModal
            skipInventoryValidation={skipInventoryValidation}
            skipProductPrice={skipProductPrice}
        />
        <ProductDeliveryScheduleModal />
        {/* Verndale Customization */}
        <AddToListModal />
        <ShareListModal />
        <InventoryResultsModal />
        <SpoolModal />
        <AddedToCartModal />
    </>
);

export default Modals;
